import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useLocation, useNavigate } from 'react-router-dom';

export function useNavigateWithQuery() {
  const plainNavigate = useNavigate();
  const location = useLocation();

  const navigate = useCallback(
    (path: string | number, keepQueryString = false, replace = false) => {
      if (typeof path === 'number') {
        plainNavigate(path);
        return;
      }
      const target = keepQueryString ? `${path}${location.search}` : path;
      plainNavigate(target, { replace });
    },
    [plainNavigate, location.search],
  );

  return navigate;
}
